#import "../fragments/contact-summary-fragment.graphql"

query GetContactSummary($id: ID!) {
    contact(id: $id) {
        ...ContactSummaryFragment
    }
}
